import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { MonthService, monthLabel } from './month.service';

@Component({
  selector: 'app-month-picker',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, MatIconModule],
  template: `
    <div class="month-picker">
      <button mat-icon-button (click)="months.shift(-1)" title="Mês anterior"><mat-icon>chevron_left</mat-icon></button>
      <span class="label">{{ label(months.month$ | async) }}</span>
      <button mat-icon-button (click)="months.shift(1)" title="Próximo mês"><mat-icon>chevron_right</mat-icon></button>
    </div>
  `,
  styles: [`
    .month-picker { display: inline-flex; align-items: center; gap: 4px; }
    .label { min-width: 150px; text-align: center; font-weight: 500; }
  `]
})
export class MonthPickerComponent {
  months = inject(MonthService);

  label(month: string | null): string {
    return month ? monthLabel(month) : '';
  }
}
